import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
  Modal, Button, FormGroup, ControlLabel, FormControl,
  HelpBlock,
} from 'react-bootstrap';

import { trim, isArray, tail } from 'lodash';
import Fa from 'react-fontawesome';

// Import Selectors
import { requestUpdateOrganization } from '../../../Admin/AdminActions';
import styles from './styles.css';

class InvitationExclusionPage extends Component {
  constructor() {
    super();
    this.state = {
      hasFileReader: typeof window.FileReader !== 'undefined',
    };
    this.renderField = this.renderField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount() {
    this.initData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const currentOrgId = this.props.organization ? this.props.organization._id : null;
    const nextOrgId = nextProps.organization ? nextProps.organization._id : null;
    if ((nextOrgId && currentOrgId !== nextOrgId) || (this.props.showModal !== nextProps.showModal && nextProps.showModal)) {
      this.initData(nextProps);
    }
  }

  initData(props) {
    const { organization } = props;
    if (organization) {
      if (organization.bypass_invitation === true) {
        this.props.initialize({ bypass_invitation: true, invitation_exclusion_list: null });
      } else {
        const data = isArray(organization.invitation_exclusion_list || []) ? (organization.invitation_exclusion_list || []).join('\n') : (organization.invitation_exclusion_list || '');
        this.props.initialize({ bypass_invitation: false, invitation_exclusion_list: trim(data) });
      }
    }
  }

  close() {
    this.props.onClose();
  }

  handleSubmit(data) {
    const { organization } = this.props;
    const params = {
      invitation_exclusion_list: data.invitation_exclusion_list,
      bypass_invitation: data.bypass_invitation,
    };
    if (params.bypass_invitation === true) {
      delete params.invitation_exclusion_list;
    }
    const p = this.props.dispatch(requestUpdateOrganization(organization._id, params));
    p.then(
      () => {
        if (this.props.isModal) {
          this.close();
        }
      }
    );
    return p;
  }


  handleFileChange(e) {
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result ? reader.result.toString() : '';
      const data = tail(content.split('\n')).join('\n');
      this.props.change('invitation_exclusion_list', data);
    };
    // start reading the file. When it is done, calls the onload event defined above.
    reader.readAsBinaryString(e.target.files[0]);
  }

  renderField({
    input, label, type, meta: { touched, error }, componentClass, placeholder, className,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}</ControlLabel>}
        <FormControl {...input} componentClass={componentClass} className={className} placeholder={(placeholder || label)} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderInnerForm() {
    const {
      submitting,
      bypassInvitation,
      organization,
    } = this.props;
    let instanceName = 'CRM';
    if (organization.type === 'azure') {
      instanceName = 'Microsoft Dynamics';
    } else if (organization.type === 'hubspot') {
      instanceName = 'HubSpot';
    } else if (organization.type === 'force') {
      instanceName = 'Salesforce';
    }
    const options = [
      { id: 1, value: true, label: `Login with ${instanceName} credentials` },
      { id: 2, value: false, label: 'Login with a unique TruVoice Automation invitation code. Except the following users:' },
    ];

    return (
      <div>
        {options.map((o) => {
          const active = o.value === bypassInvitation;
          return (
            <div key={o.id} style={{ cursor: 'pointer', margin: '15px 0' }} onClick={() => { this.props.change('bypass_invitation', o.value) }}>
              <Fa name={active ? 'check-circle' : 'circle-o'} className={active ? 'text-success' : ''} /> {o.label}
            </div>
          );
        })}
        {!bypassInvitation &&
          <div style={{ paddingLeft: 15 }}>
            <Field className={styles.textarea} componentClass="textarea" name="invitation_exclusion_list" component={this.renderField} placeholder="Please enter one User Id or email per line, no commas" />
              {this.state.hasFileReader &&
                <ul>
                  <li>
                    Or you can <span className={styles.uploader}><a href="">upload</a><input accept=".csv" disabled={submitting} id="csv" type="file" onChange={this.handleFileChange} /></span> an <code>.csv</code>
                    {' '}
                    file that contains the sales reps&rsquo; emails or User Id.
                  </li>
                  <li><a href="/assets/sample.csv" target="_blank">Click here</a> to download a sample <code>.csv</code> file.</li>
                </ul>
              }
          </div>
        }
      </div>
    );
  }

  renderForm() {
    const {
      handleSubmit, submitting, organization,
    } = this.props;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)} key={organization._id}>
        <div className="panel panel-default">
          <div className="panel-heading">
            New user login requirements:
          </div>
          <div className="panel-body">
            {this.renderInnerForm()}
          </div>
          <div className="panel-footer text-right">
            <Button disabled={submitting} bsStyle="primary" type="submit">
              {!submitting && <span>Save</span>}
              {submitting && <span>Saving</span>}
            </Button>
          </div>
        </div>
        <div style={{ height: 200 }} />
      </form>
    );
  }

  renderModal() {
    const {
      handleSubmit, submitting, organization,
      showModal,
    } = this.props;
    const name = organization ? organization.display_name : '';

    return (
      <Modal show={showModal} onHide={this.close}>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{name} | New user login requirements:</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderInnerForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={submitting} bsStyle="primary" type="submit">
              {!submitting && <span>Save</span>}
              {submitting && <span>Saving</span>}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  renderInline() {
    return (
      <div>
        <Helmet title="New Users | Organization Setup" />
        <div className="container">
          {this.renderForm()}
        </div>
      </div>
    );
  }


  render() {
    const { isModal } = this.props;
    if (isModal) {
      return this.renderModal();
    }
    return this.renderInline();
  }
}

const selector = formValueSelector('organizationInvitationExclusionForm'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    bypassInvitation: selector(state, 'bypass_invitation'),
  };
}

InvitationExclusionPage.propTypes = {
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  change: PropTypes.func,
  isModal: PropTypes.bool,
  onClose: PropTypes.func,
  showModal: PropTypes.bool,
  bypassInvitation: PropTypes.bool,
};

InvitationExclusionPage.defaultProps = {
  isModal: false,
  organization: null,
  onClose: () => {},
  showModal: false,
  bypassInvitation: false,
};

InvitationExclusionPage.contextTypes = {
};

const InvitationExclusionForm = reduxForm({
  form: 'organizationInvitationExclusionForm',
})(InvitationExclusionPage);

export default connect(mapStateToProps)(InvitationExclusionForm);
